import { Box, Button, Modal, Switch, Tab, Tabs, Typography } from '@mui/material';
import { X } from 'lucide-react';
import Image from 'next/image';
import Link from 'next/link';
import React from 'react';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `vertical-tab-${index}`,
    'aria-controls': `vertical-tabpanel-${index}`,
  };
}
export default function Cookies(props: any) {
  const { value, handleChange, openCookiesModal, setOpenCookiesModal, Style } = props;

  return (
    <>
      <Modal
        open={openCookiesModal}
        onClose={setOpenCookiesModal} // Handle backdrop clicks
        className="border-0 mx-4"
        aria-labelledby="keep-mounted-modal-title"
        aria-describedby="keep-mounted-modal-description"
        disableEscapeKeyDown
        sx={{
          '& .MuiBackdrop-root': {
            backdropFilter: 'blur(4px)', // Applying a blur filter to the backdrop
          },
        }}
      >
        <>
          <Box
            sx={{
              ...Style,
              border: 'none',
              outline: 'none',
              flexGrow: 1,
              bgcolor: 'background.paper',
              display: 'flex',
              height: 224,
            }}
            className=" sm:py-2  md:py-2 lg:py-2 lg:max-w-[65%] h-[90%]  mx-auto w-full flex flex-col items-center"
          >
            <div className="flex relative h-full flex-col w-full justify-between">
              <div className="flex flex-col">
                <div className="flex border-b-2 px-2 w-full justify-between">
                  <div className="flex items-center">
                    <Image
                      src="/blueLogo.svg"
                      height={100}
                      className="  w-[100px] h-[60px] sm:w-[200px] sm:h-[80px] md:w-[200px] md:h-[80px] lg:w-[200px] lg:h-[80px] p-4"
                      width={100}
                      alt="Logo"
                    />
                    <h1 className="  hidden sm:flex md:flex lg:flex text-sm  sm:text-lg md:text-2xl lg:text-2xl font-semibold">
                      Privacy preference center
                    </h1>
                  </div>
                  <div
                    role="button"
                    aria-label="Close"
                    style={{ border: '1px solid black' }}
                    className="flex items-center justify-center absolute cursor-pointer bg-white h-6 w-6 rounded-full -top-2 -right-1"
                  >
                    <X
                      onClick={() => {
                        setOpenCookiesModal(false);
                      }}
                      className="transition-transform duration-300 ease-in-out hover:rotate-180"
                    />
                  </div>
                </div>

                {/* Middle */}
                <div
                  className="flex w-full  flex-col  md:flex-row lg:flex-row  overflow-auto  "
                  style={{ maxHeight: '63vh' }}
                >
                  <Tabs
                    orientation="vertical"
                    variant="scrollable"
                    value={value}
                    onChange={handleChange}
                    aria-label="Vertical tabs example"
                    sx={{
                      borderRight: 1,
                      borderColor: 'divider',
                      minWidth: '280px',
                      overflowY: 'auto', // Enable vertical scrolling for the tab labels
                    }}
                  >
                    <Tab
                      label="Your Privacy"
                      {...a11yProps(0)}
                      sx={{
                        display: 'flex',
                        alignItems: 'flex-start',
                        justifyContent: 'flex-start',
                        minHeight: 0,
                        fontWeight: '500',
                      }}
                    />
                    <Tab
                      label="Strictly Necessary Cookies"
                      {...a11yProps(1)}
                      sx={{
                        display: 'flex',
                        alignItems: 'flex-start',
                        fontWeight: '500',
                        minHeight: 0,
                      }}
                    />
                    <Tab
                      label="Performance Cookies"
                      {...a11yProps(2)}
                      sx={{
                        display: 'flex',
                        alignItems: 'flex-start',
                        fontWeight: '500',
                        minHeight: 0,
                      }}
                    />
                    <Tab
                      label="Targeting Cookies"
                      {...a11yProps(3)}
                      sx={{
                        display: 'flex',
                        alignItems: 'flex-start',
                        fontWeight: '500',
                        minHeight: 0,
                      }}
                    />
                  </Tabs>
                  <div className="flex-1 overflow-auto max-h-[28vh]  sm:max-h-screen md:max-h-screen lg:max-h-screen ">
                    <TabPanel value={value} index={0}>
                      <h2 className="font-semibold">Your Privacy</h2>

                      <p className="py-2">
                        When you visit any website, it may store or retrieve information on your browser, mostly in the
                        form of cookies. This information might be about you, your preferences or your device and is
                        mostly used to make the site work as you expect it to. The information does not usually directly
                        identify you, but it can give you a more personalized web experience. Because we respect your
                        right to privacy, you can choose not to allow some types of cookies. Click on the different
                        category headings to find out more and change our default settings. However, blocking some types
                        of cookies may impact your experience of the site and the services we are able to offer.
                        <Link href="/" className="text-[#1976D2]">
                          {' '}
                          Cookies Details
                        </Link>
                      </p>
                      <p>
                        <span className="font-semibold text-lg">User ID:</span> af3fafbb-b885-4afa-ab74-5eaf2fc58512
                      </p>
                    </TabPanel>
                    <TabPanel value={value} index={1}>
                      <div className="flex w-full justify-between">
                        <h2 className="font-semibold">Strictly Necessary Cookies</h2>
                        <h2 className="text-[#1976D2] hidden sm:flex md:flex lg:flex font-semibold">Always Active</h2>
                      </div>

                      <p className="py-2">
                        These cookies are necessary for the website to function and cannot be switched off in our
                        systems. They are usually only set in response to actions made by you which amount to a request
                        for services, such as setting your privacy preferences, logging in or filling in forms. You can
                        set your browser to block or alert you about these cookies, but some parts of the site will not
                        then work. These cookies do not store any personally identifiable information.
                        <Link href="/" className="text-[#1976D2]">
                          {' '}
                          More Information
                        </Link>
                      </p>
                    </TabPanel>
                    <TabPanel value={value} index={2}>
                      <div className="flex w-full justify-between items-center">
                        <h2 className="font-semibold">Performance Cookies</h2>
                        <h2 className="text-[#1976D2] font-semibold">
                          <Switch />
                        </h2>
                      </div>

                      <p className="py-2">
                        These cookies allow us to count visits and traffic sources so we can measure and improve the
                        performance of our site. They help us to know which pages are the most and least popular and see
                        how visitors move around the site. All information these cookies collect is aggregated and
                        therefore anonymous. If you do not allow these cookies we will not know when you have visited
                        our site, and will not be able to monitor its performance.
                        <Link href="/" className="text-[#1976D2]">
                          {' '}
                          Cookies Details
                        </Link>
                      </p>
                    </TabPanel>
                    <TabPanel value={value} index={3}>
                      <div className="flex w-full justify-between items-center">
                        <h2 className="font-semibold">Targeting Cookies</h2>
                        <Switch />
                      </div>

                      <p className="py-2">
                        These cookies may be set through our site by our advertising partners. They may be used by those
                        companies to build a profile of your interests and show you relevant adverts on other sites.
                        They do not store directly personal information, but are based on uniquely identifying your
                        browser and internet device. If you do not allow these cookies, you will experience less
                        targeted advertising.
                        <Link href="/" className="text-[#1976D2]">
                          {' '}
                          Cookies Details
                        </Link>
                      </p>
                    </TabPanel>
                  </div>
                </div>
              </div>

              {/* Footer */}
              <div className=" absolute sm:relative md:relative lg:relative bottom-0 flex w-full mt-2  flex-col  sm:flex-row md:flex-row lg:flex-row justify-between px-2">
                <Button
                  style={{ border: '2px solid #1976D2' }}
                  className="normal-case py-1 sm:py-2 md:py-2 lg:py-2 sm:mb-2 md:mb-2 lg:mb-2"
                  onClick={() => {
                    setOpenCookiesModal(false);
                  }}
                >
                  Confirm My Choice
                </Button>
                <div className="flex mt-2 sm:mt-0 md:mt-0 lg:mt-0 items-center pb-2">
                  <Button
                    style={{ border: '2px solid #1976D2' }}
                    className="normal-case w-full sm:w-auto md:w-auto lg:w-auto me-1 py-1 sm:py-2 md:py-2 lg:py-2"
                    onClick={() => {
                      setOpenCookiesModal(false);
                    }}
                  >
                    Reject All
                  </Button>
                  <Button
                    onClick={() => {
                      setOpenCookiesModal(false);
                    }}
                    style={{ border: '2px solid #1976D2' }}
                    className="normal-case ms-1 w-full sm:w-auto md:w-auto lg:w-auto bg-[#1976D2] text-white py-1 sm:py-2 md:py-2 lg:py-2"
                  >
                    Allow All
                  </Button>
                </div>
              </div>
            </div>
          </Box>
        </>
      </Modal>
    </>
  );
}
